// extracted by mini-css-extract-plugin
export default {"container":"CustomerDetails_container__ZXCro","inputField":"CustomerDetails_inputField__5SzBd"};